<template>
  <b-container fluid class="bulk-loading-container py-4">
    <b-row>
      <b-col md="12">
        <b-card class="shadow-sm">
          <template #header>
            <div class="d-flex align-items-center">
              <b-icon-cloud-upload class="mr-2 text-primary" font-scale="1.5"></b-icon-cloud-upload>
              <h4 class="mb-0">{{ $t("toolbar.adminUsers.bulkDataLoading").toUpperCase() }}</h4>
            </div>
          </template>

          <!-- Descripción informativa -->
          <b-alert show variant="info" class="mb-4">
            <b-icon-info-circle class="mr-2"></b-icon-info-circle>
            <strong>{{ $t("toolbar.adminUsers.howItWorks") }}</strong> {{ $t("toolbar.adminUsers.bulkLoadingDescription") }}
          </b-alert>

          <!-- Proceso en pasos -->
          <div class="process-steps mb-4">
            <b-row>
              <b-col md="4" class="text-center mb-3">
                <div class="step-icon mb-2">
                  <b-icon-download class="text-primary" font-scale="2"></b-icon-download>
                </div>
                <h5>1. {{ $t("reusable.common.download") }}</h5>
                <p class="text-muted">{{ $t("toolbar.adminUsers.downloadStepDescription") }}</p>
              </b-col>
              <b-col md="4" class="text-center mb-3">
                <div class="step-icon mb-2">
                  <b-icon-pencil-square class="text-success" font-scale="2"></b-icon-pencil-square>
                </div>
                <h5>2. {{ $t("reusable.common.complete") }}</h5>
                <p class="text-muted">{{ $t("toolbar.adminUsers.completeStepDescription") }}</p>
              </b-col>
              <b-col md="4" class="text-center mb-3">
                <div class="step-icon mb-2">
                  <b-icon-envelope class="text-warning" font-scale="2"></b-icon-envelope>
                </div>
                <h5>3. {{ $t("reusable.common.contact") }}</h5>
                <p class="text-muted">{{ $t("toolbar.adminUsers.contactStepDescription") }}</p>
              </b-col>
            </b-row>
          </div>

          <!-- Sección de plantillas -->
          <h5 class="mb-3">
            <b-icon-file-earmark-spreadsheet class="mr-2"></b-icon-file-earmark-spreadsheet>
            {{ $t("toolbar.adminUsers.availableTemplates") }}
          </h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card class="h-100 template-card">
                <div class="d-flex align-items-center mb-2">
                  <b-icon-file-earmark-text class="mr-2 text-primary" font-scale="1.5"></b-icon-file-earmark-text>
                  <h6 class="mb-0">{{$getVisibleNames('teaching.section', true, 'Secciones')}}</h6>
                </div>
                <p class="text-muted small">
                  {{
                    $t("toolbar.adminUsers.bulkLoadingTemplateFor", {
                      entity: $getVisibleNames('teaching.section', false, 'secciones')
                    })
                  }}
                </p>
                <GenericButtonDownload
                  :tooltip_text="$t('toolbar.adminUsers.downloadTemplateXLSX')"
                  :click_button="downloadExcelSectionTemplate"
                  :icon_excel="true"
                  :text_button="$t('reusable.common.download')"
                  block
                ></GenericButtonDownload>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card class="h-100 template-card">
                <div class="d-flex align-items-center mb-2">
                  <b-icon-diagram-3 class="mr-2 text-success" font-scale="1.5"></b-icon-diagram-3>
                  <h6 class="mb-0">{{$getVisibleNames('mesh.career', true, 'Programas')}}</h6>
                </div>
                <p class="text-muted small">
                  {{
                    $t("toolbar.adminUsers.bulkLoadingTemplateFor", {
                      entity: $getVisibleNames('mesh.career', false, 'programas')
                    })
                  }}
                </p>
                <GenericButtonDownload
                  :tooltip_text="$t('toolbar.adminUsers.downloadTemplateXLSX')"
                  :click_button="downloadExcelTemplate"
                  :icon_excel="true"
                  :text_button="$t('reusable.common.download')"
                  block
                ></GenericButtonDownload>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
import {
  toast,
  showLoadingAlert,
  downloadFileFromResponse,
} from "@/utils/utils";
export default {
  name: "InstitutionBulkLoading",
  components: {
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    downloadExcelSectionTemplate() {
      showLoadingAlert(
        this.$t("toolbar.adminUsers.generatingTemplate"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Get("/teaching/generate_section_import_excel/", {
          responseType: "blob",
        })
        .then((response) => {
          this.$swal.close();
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {
              toast(this.$t("toolbar.adminUsers.templateDownloadedSuccessfully"));
            },
            () => {
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    downloadExcelTemplate() {
      showLoadingAlert(
        this.$t("toolbar.adminUsers.generatingTemplate"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Get("/mesh/generate_mesh_import_excel/", {
          responseType: "blob",
        })
        .then((response) => {
          this.$swal.close();
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {
              toast(this.$t("toolbar.adminUsers.templateDownloadedSuccessfully"));
            },
            () => {
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
  },
  created() {},
};
</script>

<style scoped>
.bulk-loading-container {
  max-width: 1200px;
  margin: 0 auto;
}

.template-card {
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.template-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.step-icon {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

